export default "__VITE_ASSET__61974597__"